import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_exchangea_dark",
  "use": "icon-ic_exchangea_dark-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_exchangea_dark\">\r\n<path d=\"M25 11H7V13H25V11Z\" fill=\"#F6F6F6\" />\r\n<path d=\"M25.0711 11.6569L19.4142 6L18 7.41421L23.6569 13.0711L25.0711 11.6569Z\" fill=\"#3771E2\" />\r\n<path d=\"M7 21L25 21L25 19L7 19L7 21Z\" fill=\"#F6F6F6\" />\r\n<path d=\"M7.00004 20.4144L12.6569 26.0713L14.0711 24.6571L8.41425 19.0002L7.00004 20.4144Z\" fill=\"#3771E2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol